import { useContext } from 'react';
import { ThemeContext } from '../stores/ThemeContext';

export default function useTheme() {
  return useContext(ThemeContext);
}
